module.exports = __webpack_public_path__ + "img/hn.5a941825.svg";